export const VALUE_ACTIONS = [
  "contentScaling",
  "fontSizing",
  "lineHeight",
  "letterSpacing",
];

export const TOGGLE_ACTIONS = [
  "readableFont",
  "dyslexiaFont",
  "alignLeft",
  "alignCenter",
  "alignRight",
  "darkContrast",
  "lightContrast",
  "monochrome",
  "highSaturation",
  "highContrast",
  "lowSaturation",
  "highlightTitles",
  "highlightLinks",
  "highlightHover",
  "highlightFocus",
  "hideImages",
  "hideEmoji",
  "readingMask",
  "readingGuide",
  "bigBlackCursor",
  "bigWhiteCursor",
];

export const ALL_ACTIONS = [...VALUE_ACTIONS, ...TOGGLE_ACTIONS];

export const ACTION_GROUPS = {
  align: ["alignLeft", "alignCenter", "alignRight"],
  chromatic: [
    "darkContrast",
    "lightContrast",
    "monochrome",
    "highSaturation",
    "highContrast",
    "lowSaturation",
  ],
  cursors: ["bigBlackCursor", "bigWhiteCursor"],
};

export const ACTION_LABELS = {
  contentScaling: "Content Scaling",
  fontSizing: "Font Sizing",
  lineHeight: "Line Height",
  letterSpacing: "Letter Spacing",
  readableFont: "Readable Font",
  dyslexiaFont: "Dyslexia Friendly",
  alignLeft: "Align Left",
  alignCenter: "Align Center",
  alignRight: "Align Right",
  darkContrast: "Dark Contrast",
  lightContrast: "Light Contrast",
  monochrome: "Monochrome",
  highSaturation: "High Saturation",
  highContrast: "High Contrast",
  lowSaturation: "Low Saturation",
  highlightTitles: "Highlight Titles",
  highlightLinks: "Highlight Links",
  highlightHover: "Highlight Hover",
  highlightFocus: "Highlight Focus",
  hideImages: "Hide Images",
  hideEmoji: "Hide Emoji",
  readingMask: "Reading Mask",
  readingGuide: "Reading Guide",
  bigBlackCursor: "Big Dark Cursor",
  bigWhiteCursor: "Big Light Cursor",
};

export const ACTION_LABELS_IT = {
  contentScaling: "Scala Contenuti",
  fontSizing: "Dimensione Font",
  lineHeight: "Interlinea",
  letterSpacing: "Spaziatura Lettere",
  readableFont: "Font Leggibile",
  dyslexiaFont: "Font Dislessia",
  alignLeft: "Allinea a Sinistra",
  alignCenter: "Allinea al Centro",
  alignRight: "Allinea a Destra",
  darkContrast: "Contrasto Scuro",
  lightContrast: "Contrasto Chiaro",
  monochrome: "Monocromatico",
  highSaturation: "Alta Saturazione",
  highContrast: "Alto Contrasto",
  lowSaturation: "Bassa Saturazione",
  highlightTitles: "Evidenzia Titoli",
  highlightLinks: "Evidenzia Link",
  highlightHover: "Evidenzia Hover",
  highlightFocus: "Evidenzia Focus",
  hideImages: "Nascondi Immagini",
  hideEmoji: "Nascondi Emoji",
  readingMask: "Maschera Lettura",
  readingGuide: "Guida Lettura",
  bigBlackCursor: "Cursore Scuro Grande",
  bigWhiteCursor: "Cursore Chiaro Grande",
};

export const DEFAULT_TRIGGER_ICON_URL =
  "data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14%207C14%208.10457%2013.1046%209%2012%209C10.8954%209%2010%208.10457%2010%207C10%205.89543%2010.8954%205%2012%205C13.1046%205%2014%205.89543%2014%207Z%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M18%2010C18%2010%2014.4627%2011.5%2012%2011.5C9.53727%2011.5%206%2010%206%2010%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12%2012V13.4522M12%2013.4522C12%2014.0275%2012.1654%2014.5906%2012.4765%2015.0745L15%2019M12%2013.4522C12%2014.0275%2011.8346%2014.5906%2011.5235%2015.0745L9%2019%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7%203.33782C8.47087%202.48697%2010.1786%202%2012%202C17.5228%202%2022%206.47715%2022%2012C22%2017.5228%2017.5228%2022%2012%2022C6.47715%2022%202%2017.5228%202%2012C2%2010.1786%202.48697%208.47087%203.33782%207%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%2F%3E%3C%2Fsvg%3E";

export const DEFAULT_CONFIG = {
  storageKey: "readlygo",
  remember: true,
  styleNonce: "",
  showButton: true,
  startOpen: false,
  buttonLabel: "ReadlyGo",
  buttonAriaLabel: "",
  buttonTitle: "",
  buttonPosition: "bottom-left",
  buttonVariant: "icon",
  buttonIconUrl: DEFAULT_TRIGGER_ICON_URL,
  buttonIconSize: 22,
  buttonBackground: "",
  buttonTextColor: "",
  buttonIconColor: "",
  buttonBorderColor: "",
  buttonBoxShadow: "",
  buttonBoxShadowHover: "",
  buttonPadding: "0 4px",
  buttonMargin: 20,
  buttonOffsetX: null,
  buttonOffsetY: null,
  floatingButton: {
    enabled: true,
    position: "bottom-left",
    variant: "icon",
    iconUrl: DEFAULT_TRIGGER_ICON_URL,
    iconSize: 22,
    label: "ReadlyGo",
    ariaLabel: "",
    title: "",
    background: "#b96cbd",
    textColor: "#ffffff",
    iconColor: "#ffffff",
    borderColor: "#a75eab",
    boxShadow: "",
    boxShadowHover: "",
    padding: "0 4px",
    margin: 20,
    offsetX: null,
    offsetY: null,
  },
  popupTitle: "ReadlyGo",
  panelSubtitle: "Accessibility Toolkit",
  defaultLanguage: "en",
  language: "en",
  rememberLanguage: true,
  languageSelector: {
    enabled: true,
    size: 18,
    showCodes: false,
  },
  localization: {
    defaultLanguage: "en",
    languages: ["en", "it"],
    flags: {
      en: "assets/flags/gb.svg",
      it: "assets/flags/it.svg",
    },
    locales: {
      en: {
        name: "English",
        panelTitle: "ReadlyGo",
        panelSubtitle: "Accessibility Toolkit",
        sections: {
          readability: "Readability",
          visualAids: "Visual Aids",
          navigationTools: "Navigation & Tools",
        },
        actions: ACTION_LABELS,
        buttons: {
          reset: "Reset",
          close: "Close",
        },
        aria: {
          closePanel: "Close ReadlyGo panel",
          togglePanel: "Toggle ReadlyGo panel",
          languageSelector: "Select language",
          languageOptionEn: "Switch to English",
          languageOptionIt: "Switch to Italian",
          increase: "Increase",
          decrease: "Decrease",
        },
      },
      it: {
        name: "Italiano",
        panelTitle: "ReadlyGo",
        panelSubtitle: "Strumenti di Accessibilita",
        sections: {
          readability: "Leggibilita",
          visualAids: "Aiuti Visivi",
          navigationTools: "Navigazione e Strumenti",
        },
        actions: ACTION_LABELS_IT,
        buttons: {
          reset: "Ripristina",
          close: "Chiudi",
        },
        aria: {
          closePanel: "Chiudi pannello ReadlyGo",
          togglePanel: "Apri pannello ReadlyGo",
          languageSelector: "Seleziona lingua",
          languageOptionEn: "Passa a inglese",
          languageOptionIt: "Passa a italiano",
          increase: "Aumenta",
          decrease: "Diminuisci",
        },
      },
    },
  },
  closeOnOverlay: true,
  readingMaskHeight: 180,
  readingGuideHeight: 14,
  assetsBaseUrl: "",
  openHotkey: "alt+a",
  theme: {
    panelBg: "#fffdf8",
    panelText: "#1b2436",
    accent: "#0f766e",
    border: "#cfe7e4",
    overlay: "rgba(6, 18, 31, 0.58)",
    triggerBg: "#b96cbd",
    triggerText: "#ffffff",
    triggerIcon: "#ffffff",
    triggerBorder: "#a75eab",
    triggerShadow: "0 10px 30px rgba(0, 16, 45, 0.28)",
    triggerShadowHover: "0 0 0 3px color-mix(in srgb, var(--rl-trigger-bg), #fff 72%)",
  },
  customTrigger: {
    enabled: true,
    selector: "readlygo-trigger,[data-readlygo-trigger]",
    variant: "icon-text",
    size: "md",
    label: "ReadlyGo",
    iconUrl: DEFAULT_TRIGGER_ICON_URL,
    background: "#b96cbd",
    color: "#ffffff",
    iconColor: "#ffffff",
    padding: "",
    borderColor: "#a75eab",
    boxShadow: "",
    boxShadowHover: "",
    title: "",
    className: "",
  },
  branding: {
    enabled: true,
    text: "Created and maintained by Caleidoscopio Web Agency",
    url: "",
    target: "_blank",
    rel: "noopener noreferrer",
  },
  labels: ACTION_LABELS,
  enable: ALL_ACTIONS.reduce((acc, action) => {
    acc[action] = true;
    return acc;
  }, {}),
  initialState: {
    toggles: TOGGLE_ACTIONS.reduce((acc, action) => {
      acc[action] = false;
      return acc;
    }, {}),
    values: {
      contentScaling: 0,
      fontSizing: 0,
      lineHeight: 0,
      letterSpacing: 0,
    },
  },
};
